import type { UseFormStateReturn } from 'react-hook-form';

export const useFormField = (formState: UseFormStateReturn<any>) => {
  const getInputClassNames = (path: string) => {
    const keys = path.split('.');
    let error: any = formState.errors;

    for (const key of keys) {
      if (!error) break;
      error = error[key];
    }

    const hasError = !!error;

    return [
      'w-full',
      'bg-gray-50',
      'border',
      hasError ? 'border-red-500' : 'border-gray-200',
      'text-gray-900',
      'px-4 py-2 rounded-lg',
      'focus:ring-2 focus:ring-purple-500 focus:border-purple-500',
      'appearance-none',
      'disabled:bg-gray-50',
      'disabled:text-gray-400',
      'disabled:placeholder-gray-300',
      'disabled:border-gray-200',
      'disabled:cursor-not-allowed',
      'disabled:focus:ring-0',
      'disabled:focus:border-gray-200',
    ].join(' ');
  };

  return { getInputClassNames };
};
